/* eslint-disable no-new */
// import AOS from 'aos';
// import 'aos/dist/aos.css';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import imagesLoaded from 'imagesloaded';
import { Swiper } from 'swiper';
import { Navigation, Keyboard } from 'swiper/modules';
import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.css';

import 'swiper/scss'; // Core
import 'swiper/scss/a11y';
import 'swiper/scss/navigation';
import 'swiper/scss/keyboard';

let currentSlug;
const project = {
	init() {
		this.hamburger();
		this.showProperHeader();
		this.fixedHeader();
		this.showMenuList();
		this.parallaxScroll();
		this.mobileMenuAnimation();
		this.headerColor();
		this.imagesLoader();
		this.newsElementCheckerboard();
		this.addProjectsBackButton();
		this.loadContentTriggers();
		this.getCurrentSlug();
	},
	hamburger() {
		const headerMenus = document.querySelectorAll('.header');
		const headerLogo = document.querySelector('.header-logo');

		headerMenus.forEach((headerMenu) => {
			const switchMenu = headerMenu.querySelector('.switch_menu');

			if (!switchMenu) {
				return null;
			}

			let switchOn = false;
			switchMenu.addEventListener('click', () => {
				if (!switchOn) {
					switchMenu.classList.add('open');
					headerMenu.classList.add('open');
					headerLogo.classList.add('open');
					document.body.classList.add('prevent-scroll');
					switchOn = true;
				} else {
					switchMenu.classList.remove('open');
					headerMenu.classList.remove('open');
					headerLogo.classList.remove('open');
					document.body.classList.remove('prevent-scroll');
					switchOn = false;
				}
			});

			window.addEventListener('resize', () => {
				if (switchOn) {
					switchMenu.classList.remove('open');
					headerMenu.classList.remove('open');
					switchOn = false;
					document.body.classList.remove('prevent-scroll');
				}
			});
		});

		return null;
	},
	showProperHeader() {
		const headerUnfixed = document.querySelector('.header--unfixed');
		const scrollPosition = window.pageYOffset;

		window.addEventListener('scroll', () => {
			const scrollPosition = window.pageYOffset;

			if (scrollPosition >= 400) {
				headerUnfixed.classList.remove('header--to-top');
			}

			if (scrollPosition < 400) {
				headerUnfixed.classList.add('header--to-top');
			}
		});
	},
	// eslint-disable-next-line consistent-return
	fixedHeader() {
		const e = document.getElementsByClassName('header--unfixed');

		let t = {};
		if (0 === e.length) return !1;
		e[0].classList.remove('header--show'),
			(t = {
				x: window.pageXOffset,
				y: window.pageYOffset,
			}),
			t.y > 100
				? e[0].classList.add('header--scroll')
				: e[0].classList.remove('header--scroll');
	},
	unfixedHeader() {
		const e = document.getElementsByClassName('header--unfixed');
		let t = {};
		if (0 === e.length) return !1;
		(t = {
			x: window.pageXOffset,
			y: window.pageYOffset,
		}),
			e[0].classList.add('header--show'),
			t.y < 100 && e[0].classList.remove('header--scroll');
	},
	showMenuList() {
		const headers = document.querySelectorAll('.header');
		const headerLogo = document.querySelector('.header-logo');

		headers.forEach((header) => {
			const menuContentWrapper = header.querySelector(
				'.header__menu__content'
			);

			const isTop = header.classList.contains('header--top');

			const menuTitles = [
				header.querySelector('.first-menu'),
				header.querySelector('.second-menu'),
				header.querySelector('.third-menu'),
			];

			const menuContents = [
				header.querySelector('.first-menu-content'),
				header.querySelector('.second-menu-content'),
				header.querySelector('.third-menu-content'),
			];

			let clickCounters = [0, 0, 0];

			let firstOpen = true;

			let isMenuOpen = false;

			menuTitles.forEach((menuTitle, index) => {
				if (menuTitle && menuContents[index]) {
					menuTitle.addEventListener('click', () => {
						toggleMenu(index);
					});
				}
			});

			function toggleMenu(activeIndex) {
				header.classList.add('active');
				if (isTop) {
					headerLogo.classList.add('active');
				}

				isMenuOpen =
					document.querySelector('.header.active') !== null;

				if (isMenuOpen) {
					addGlobalEventListeners();
				} else {
					removeGlobalEventListeners();
				}

				clickCounters = clickCounters.map((_, i) =>
					i === activeIndex ? clickCounters[i] + 1 : 0
				);

				if (clickCounters[activeIndex] === 2) {
					header.classList.remove('active');
					if (isTop) {
						headerLogo.classList.add('active');
					}
					menuTitles[activeIndex].classList.remove(
						'active-button'
					);
					if (!firstOpen) {
						menuContentWrapper.style.transition = '';
					}
					clickCounters[activeIndex] = 0;
				}

				menuContents.forEach((content, idx) => {
					if (idx === activeIndex) {
						content.classList.toggle('open');
						if (clickCounters[activeIndex] === 1) {
							menuTitles[idx].classList.add('active-button');
							// Measure and apply height when opening
							const contentHeight = content.scrollHeight;
							menuContentWrapper.style.height = `${contentHeight}px`;
							if (!firstOpen) {
								menuContentWrapper.style.transition =
									'height 0.4s ease-in-out';
							} else {
								firstOpen = false;
							}
						}
					} else {
						content.classList.remove('open');
						menuTitles[idx].classList.remove('active-button');
					}
				});

				// If no menu is open, reset the wrapper height
				if (!document.querySelector('.header .open')) {
					menuContentWrapper.style.transition = '';
					menuContentWrapper.style.height = '0px';
					firstOpen = true;
				}

				const isAnyMenuOpen = menuContents.some((content) =>
					content.classList.contains('open')
				);
				if (!isAnyMenuOpen && isTop) {
					headerLogo.classList.remove('active');
				}
			}

			function resetMenus() {
				clickCounters = [0, 0, 0];
				menuTitles.forEach((menuTitle) => {
					menuTitle.classList.remove('active-button');
				});
				menuContents.forEach((content) => {
					content.classList.remove('open');
				});
				firstOpen = true;
				menuContentWrapper.style.transition = '';
				menuContentWrapper.style.height = '0px'; // Reset wrapper height on scroll

				if (isTop) {
					headerLogo.classList.remove('active');
				}
			}

			function addGlobalEventListeners() {
				window.addEventListener('scroll', handleGlobalEvents);
				window.addEventListener('resize', handleGlobalEvents);
				window.addEventListener('click', handleGlobalEvents);
			}

			function removeGlobalEventListeners() {
				window.removeEventListener('scroll', handleGlobalEvents);
				window.removeEventListener('resize', handleGlobalEvents);
				window.removeEventListener('click', handleGlobalEvents);
			}

			function handleGlobalEvents(event) {
				if (event.type === 'scroll' || event.type === 'resize') {
					header.classList.remove('active');
					resetMenus();
				} else if (
					event.type === 'click' &&
					!header.contains(event.target)
				) {
					header.classList.remove('active');
					if (isTop) {
						headerLogo.classList.remove('active');
					}
					resetMenus();
				}
			}
		});
	},
	parallaxScroll() {
		gsap.registerPlugin(ScrollTrigger);

		// Parallax for cover.
		const coverBg = document.querySelectorAll(
			'.has-parallax .wp-block-cover__image-background'
		);

		if (coverBg.length !== 0) {
			coverBg.forEach((img) => {
				imagesLoaded(img, () => {
					// the intended parallax animation
					gsap.fromTo(
						img,
						{
							y: 0,
						},
						{
							y: '150px',
							scrollTrigger: {
								trigger: img.closest('.wp-block-cover'),
								start: 'top',
								end: 'bottom 10%',
								scrub: true,
								invalidateOnRefresh: true,
								onRefresh: (self) => {
									if (self.start < 0) {
										self.animation.progress(
											gsap.utils.mapRange(
												self.start,
												self.end,
												0,
												1,
												0
											)
										);
									}
								},
							},
						}
					);
				});
			});
		}

		const bgLoadedAnimation = document.querySelectorAll(
			'.is-style-hero-home .wp-block-cover__image-background'
		);

		if (bgLoadedAnimation.length !== 0) {
			bgLoadedAnimation.forEach((img) => {
				imagesLoaded(img, () => {
					const tl = gsap.timeline({
						defaults: { duration: 5, ease: 'ease' },
					});

					tl.fromTo(
						img,
						{ opacity: 0, scale: 1.1 },
						{ opacity: 1, scale: 1.1, duration: 0.75 }
					).to(img, { opacity: 1, scale: 1, duration: 4.25 }, '<');
				});
			});
		}
	},
	imagesLoader() {
		const images = document.querySelectorAll('img');
		if (images.length !== 0) {
			images.forEach((image) => {
				imagesLoaded(image, () => {
					image.classList.add('loaded');
				});
			});
		}
	},
	mobileMenuAnimation() {
		const headers = document.querySelectorAll('.header');

		headers.forEach((header) => {
			header
				.querySelectorAll('.header__menu__mobile > *')
				.forEach((el, index) => {
					// Incrementing delay for each child, e.g., 0.05s, 0.1s, 0.15s, etc.
					const delay = (index + 1) * 0.05;
					el.style.setProperty('--animation-delay', `${delay}s`);
				});
		});
	},
	headerColor() {
		const heroImage = document.querySelector('.is-style-image-video');
		const headerLogo = document.querySelector('.header-logo');
		const header = document.querySelector('header');

		if (!heroImage) {
			headerLogo.classList.add('header-logo--dark');
			header.classList.add('header--dark');
			headerLogo.classList.remove('header-logo--light');
			header.classList.remove('header--light');
			setTimeout(() => {
				header.classList.add('transition-on');
			}, 300);
		} else {
			header.classList.add('transition-on');
		}
	},
	newsElementCheckerboard() {
		const page = document.querySelector('.main--page');
		if (!page) {
			return null;
		}

		const elementsGrid = page.querySelectorAll('.news-element__column');
		if (!elementsGrid) {
			return null;
		}

		elementsGrid.forEach((elementGrid, index) => {
			index++;
			if (index % 2 === 0) {
				elementGrid.classList.add('right');
			}
		});
	},
	addProjectsBackButton() {
		const post = document.querySelector('.container--project');
		if (!post) {
			return null;
		}
		const button = post.querySelector(
			'.post-map__button-wrapper__button'
		);
		if (!button) {
			return null;
		}
		const projectArchive = SiteVars.homeUrl + '/projects';
		button.setAttribute('href', projectArchive);

		const url = window.location.href;
		if (window.location.href.indexOf('/de') != -1) {
			button.innerHTML = 'Alle Projekte';
		}
	},
	initSlider(postId) {
		const popup = document.getElementById(`content-${postId}`);
		if (!popup) return;

		const sliders = popup.querySelectorAll('.slider');
		if (sliders.length === 0) return;

		sliders.forEach((slider, index) => {
			initGLightbox(slider, index);
			initSwiper(slider);
		});

		function initGLightbox(slider, index) {
			const glighboxElements = slider.querySelectorAll('.glightbox');
			if (glighboxElements.length === 0) return;

			glighboxElements.forEach((glighboxElement) => {
				glighboxElement.classList.add(`glightbox-${index}`);
			});

			const lightbox = GLightbox({
				selector: `.glightbox-${index}`,
				openEffect: 'fade',
				closeEffect: 'fade',
				loop: true,
			});

			lightbox.on('slide_after_load', (event) => {
				const image = event.slideNode.querySelector('img');
				if (!image) return;

				image.classList.add(
					image.width > image.height ? 'full-width' : 'full-height'
				);
			});
		}

		function initSwiper(slider) {
			if (slider.querySelectorAll('.swiper-slide').length <= 1)
				return;

			new Swiper(slider.querySelector('.swiper'), {
				modules: [Navigation, Keyboard],
				slidesPerView: 1,
				spaceBetween: 10,
				speed: 700,
				keyboard: {
					enabled: true,
					onlyInViewport: false,
				},
				navigation: {
					nextEl: slider.querySelector('.swiper-button-next'),
					prevEl: slider.querySelector('.swiper-button-prev'),
				},
				on: {
					slideChange() {
						const texts = slider.querySelectorAll(
							'.slider__texts-container__text-wrapper'
						);
						texts.forEach((text) => {
							text.style.display =
								this.realIndex.toString() ===
									text.getAttribute('data-text')
									? 'flex'
									: 'none';
						});
					},
				},
			});
		}
	},
	getPublicationTemplate(data) {
		const contentWrapper = document.createElement('div');
		contentWrapper.id = `content-${data.id}`;
		contentWrapper.className = 'content__wrapper active';

		contentWrapper.innerHTML = `<div class="container container--activity">${data.content.rendered}</div>`;

		return contentWrapper;
	},
	wrapperTemplate(data) {
		return this.getPublicationTemplate(data);
	},
	loadContent(postId) {
		if (!postId) {
			return;
		}

		const fetchPostData = async (postId) => {
			try {
				const response = await fetch(
					`${SiteVars.siteUrl}/wp-json/wp/v2/activity-report/${postId}`
				);
				const data = await response.json();
				const wrapper = document.querySelector(
					'.dynamic__wrapper.overlay'
				);

				// Ensure data exists before proceeding
				if (data) {
					const contentWrapper = this.wrapperTemplate(data);
					wrapper.appendChild(contentWrapper);
					this.initSlider(postId);
					const images = wrapper.querySelectorAll('img');
					images.forEach((image) => {
						imagesLoaded(image, () => {
							image.classList.add('loaded');
						});
					});

					wrapper.classList.remove('loading');
				}
			} catch (error) {
				console.error('Error:', error);
			}
		};

		fetchPostData(postId);
	},
	getLang() {
		const htmlLang = document.documentElement.getAttribute('lang') || '';
		const shortLang = '/' + htmlLang.split("-")[0].toLowerCase();

		return shortLang !== '/en' ? shortLang : '';
	},
	loadSlug(postId) {
		if (!postId) {
			return;
		}

		const fetchPostData = async (postId) => {
			try {
				const response = await fetch(
					`${SiteVars.siteUrl}/wp-json/wp/v2/activity-report/${postId}`
				);
				const data = await response.json();

				const shortLang = project.getLang();

				// Ensure data exists before proceeding
				if (data) {
					// Fetch parent post data if available
					if (data.parent && data.parent !== 0) {
						const parentResponse = await fetch(
							`${SiteVars.siteUrl}/wp-json/wp/v2/activity-report/${data.parent}`
						);
						const parentData = await parentResponse.json();
						window.history.pushState(
							'dynamicWrapper',
							data.title.rendered,
							`${shortLang}/activity-report/${parentData.slug}/${data.slug}/`
						);
					}
				}
			} catch (error) {
				console.error('Error:', error);
			}
		};

		fetchPostData(postId);
	},
	loadContentTriggers() {
		const buttons = document.querySelectorAll('.js-popup');
		const close = document.querySelector(
			'.dynamic__wrapper__close.overlay'
		);
		const dynamicWrapper = document.querySelector(
			'.dynamic__wrapper.overlay'
		);
		const bodyTag = document.querySelector('body');

		if (buttons.length === 0) {
			return;
		}

		// Open popup and decide if fetch new content.

		buttons.forEach((button) => {
			button.addEventListener('click', (e) => {
				e.preventDefault();
				const postId = button.dataset.post_id;
				if (postId) {
					const loadedContent = document.getElementById(
						`content-${postId}`
					);
					if (loadedContent) {
						loadedContent.classList.add('active');
						this.loadSlug(postId);
					} else {
						dynamicWrapper.classList.add('loading');
						this.loadContent(postId);
						this.loadSlug(postId);
					}

					dynamicWrapper.classList.add('active');
					bodyTag.style.overflow = 'hidden';

					dynamicWrapper.style.display = 'block';
					setTimeout(function () {
						dynamicWrapper.style.opacity = 1;
					}, 100);
				}
			});
		});

		// Close popup after click back in browser.
		window.onpopstate = function () {
			close.click();
		};

		// Close popup.
		close.addEventListener('click', () => {
			const loadedContents =
				document.querySelectorAll('.content__wrapper');

			dynamicWrapper.style.opacity = 0;
			setTimeout(function () {
				dynamicWrapper.style.display = 'none';
				loadedContents.forEach((loadedContent) => {
					dynamicWrapper.classList.remove('active');
					dynamicWrapper.classList.remove('project');
					loadedContent.classList.remove('active');
					bodyTag.style.overflow = 'auto';
					window.history.pushState(
						'dynamicWrapper',
						'Homepage',
						currentSlug
					);
				});
			}, 300);
		});
	},
	getCurrentSlug() {
		const url = window.location.href.split(/[?#]/)[0];
		const shortLang = project.getLang();
		if (url.match(/https?:\/\/[^\/]+\/$/)) {
			currentSlug = '/';
			return;
		}
		const segments = url.split('/').filter(Boolean);
		currentSlug =
			segments.length > 0
				? `${shortLang}/${segments[segments.length - 2]}/${segments[segments.length - 1]
				}/`
				: '';
	},
	aos() {
		AOS.init();
	},
};

document.addEventListener('DOMContentLoaded', () => {
	project.init();
});

let lastScrollTop = 0,
	st = 0;
window.addEventListener('scroll', () => {
	const st = window.pageYOffset || document.documentElement.scrollTop;

	// Use the ternary operator to decide which function to call
	Math.abs(st) < Math.abs(lastScrollTop)
		? project.unfixedHeader()
		: project.fixedHeader();

	// Update lastScrollTop
	lastScrollTop = st;
});
